import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function Modal({ open, onClose, title, description, children, wide, testid = "modal" }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className={`max-h-[92vh] overflow-y-auto bg-white ${wide ? "max-w-5xl" : "max-w-xl"}`} data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="text-xl font-extrabold text-[#16163F]">{title}</DialogTitle>
          <div className="h-0.5 w-8 bg-[#A5894E]" />
          {description && <DialogDescription className="text-[#6B6B80]">{description}</DialogDescription>}
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export function PromptModal({ open, onClose, title, label, onSubmit, confirmLabel = "Confirmer", danger, testid = "prompt-modal" }) {
  return (
    <Modal open={open} onClose={onClose} title={title} testid={testid}>
      <form onSubmit={(e) => { e.preventDefault(); onSubmit(new FormData(e.target).get("v")); }} className="space-y-4">
        <label className="block"><span className="lbl">{label}</span><textarea name="v" required rows={3} className="inp" data-testid={`${testid}-input`} /></label>
        <div className="flex justify-end gap-2">
          <button type="button" className="btn-ghost" onClick={onClose}>Annuler</button>
          <button className={danger ? "btn-danger" : "btn-primary"} data-testid={`${testid}-confirm`}>{confirmLabel}</button>
        </div>
      </form>
    </Modal>
  );
}
